import { virtualDir } from "#skyward_global";
import { DEFAULT_CLOSE_BUTTON, showDialog } from "#skyward_modalLayer";
import { notifyDOMLoad } from "#skyward_window";
import { registerEvents } from "./skyward.ui.events";
import { registerTabFunction } from "./skyward.ui.tablist";
import { JQueryInput } from "./types";
import { ExternalLinkCard, ExternalLinkCardContext } from "./vue/externalLinks/ExternalLinkCard";

const skyward = window.skyward;

const classNames =
{
    externalLinksContainer: "externalLinksModal__container",
    externalLinksLeft: "externalLinksModal__left",
    externalLinksRight: "externalLinksModal__right",
    tabListContainer: "tabListContainer",
    tabListItem: "tabListItem",
    current: "current",
    dashboardItemConfigurationContainer: "dashboardItemConfiguration__container",
    currentRecordContentBaseError: "currentRecordContentBaseError"
};

registerEvents("externalLinks",
    {
        openModal,
        init,
        initCard,
        setCurrentTab,
        buildLegendPopup
    }
);

async function buildLegendPopup(this: JQueryInput)
{
    const legendButton = $(this);

    const content = await $.ajax(
        {
            url: `${virtualDir}SkySys/ExternalLink/Legend`,
            type: "POST",
            dataType: "viewparthtml",
            activityIndicator: { hideGlass: true }
        });

    showDialog("Legend", content, [DEFAULT_CLOSE_BUTTON], { anchorTo: legendButton, titleTag: "h1" });
}

async function setCurrentTab(tab: JQueryInput)
{
    const tabElement = $(tab);
    const tabListElement = tabElement.closest(`.${classNames.tabListContainer}`)
    const dialogContainer = tabListElement.closest(`.${classNames.externalLinksContainer}`);

    const tabData = tabElement.data("tab");

    if (tabElement.length === 0 || tabData === undefined)
    {
        return;
    }

    const parent = tabElement.closest(`.${classNames.tabListContainer}`);

    const previous = parent.find(`.${classNames.current}`);

    const collectionID = tabElement.data("collection-id");
    const entityID = tabElement.data("entity-id");
    const content = $(await getCollectionContent(collectionID, entityID));

    const bodyContainer = dialogContainer.find(`.${classNames.externalLinksRight}`);
    bodyContainer.empty();

    bodyContainer.append(content);

    notifyDOMLoad(bodyContainer);

    // This is needed to get the Toolbar Buttons to not be hidden in the MoreMenu
    dialogContainer.trigger("resize");

    previous
        .removeClass(classNames.current)
        .attr("aria-selected", "false");

    tabElement
        .addClass(classNames.current)
        .attr("aria-selected", "true");
}

async function getCollectionContent(collectionID: string, entityID: bigint)
{
    return $.ajax({
        url: `${virtualDir}SkySys/ExternalLink/GetExternalLinksCollection?collectionID=${collectionID}`,
        type: "POST",
        dataType: "viewparthtml",
        data: { entityID: entityID },
    });
}

async function initCard(this: JQueryInput)
{
    const container = $(this);
    const containerData = $.extend({}, container.data());

    const context: ExternalLinkCardContext =
    {
        container: container[0],
        isMobile: skyward.global.mobileAccess,
        containerData: containerData,
    };

    ExternalLinkCard.buildVue(context);
}

async function init(this: JQueryInput)
{
    registerTabFunction("externalLinks.setCurrentTab", setCurrentTab);
    const tabListElement = $(this);
    const currentTab = tabListElement.find(`.${classNames.tabListItem}.${classNames.current}`);
    setCurrentTab(currentTab);
}

async function openModal(this: JQueryInput)
{
    const entityID = $(this).data("entity-id");

    const popupHtml = await $.ajax({
        url: `${virtualDir}SkySys/ExternalLink/GetExternalLinks/`,
        type: "POST",
        dataType: "viewparthtml",
        data: { EntityID: entityID },
    });

    showDialog(
        "Apps & External Links",
        $(popupHtml),
        undefined,
        {
            height: "95%",
            width: "90%",
            additionalContainerClasses: "externalLinksModal__modalLayer",
            closeOnClick: true,
            allowNoButtons: true,
            useMobileAccessStyles: true,
        });
}
